/**
 * The `Idempotency-Key` every mutating billing request carries.
 *
 * Standards §4 requires the header and the API refuses a request without one —
 * *"a header a client may omit is a header that will be omitted by the client
 * whose retry matters"*. This is the browser's half of that.
 *
 * **A fresh key per user action, not per request.** The point is that a retry
 * of *the same intent* is safe: a double-click, a lost response, a `fetch` the
 * browser repeats on a flaky connection. Two separate decisions — upgrading,
 * then changing your mind and upgrading to something else — are two intents and
 * must get two keys, which is why the plan code is part of it. A key that
 * lasted the whole session would make the second decision look like a retry of
 * the first and serve back the first answer.
 *
 * `crypto.randomUUID` is available in every browser this app supports and in
 * jsdom; there is no fallback because a non-random key would be worse than a
 * missing one — two tenants colliding on `checkout-1` is the failure the header
 * exists to prevent, seen from the other side.
 */
export function idempotencyKey(action: string, subject: string): string {
  return `${action}:${subject}:${crypto.randomUUID()}`
}
